/**
 * The lesson status roll-up returned by `lessons.listRange`, kept as a plain
 * union so components never import Convex server modules just for a label.
 */
export type LessonStatus =
  | "no_recording"
  | "recording"
  | "uploading"
  | "stored"
  | "queued"
  | "transcribing"
  | "transcribed"
  | "summarizing"
  | "done"
  | "failed";

export const STATUS_LABELS: Record<LessonStatus, string> = {
  no_recording: "No recording",
  recording: "Recording now",
  uploading: "Uploading",
  stored: "Stored",
  queued: "Queued for transcription",
  transcribing: "Transcribing",
  transcribed: "Transcribed, no summary",
  summarizing: "Summarizing",
  done: "Done",
  failed: "Failed",
};

export function statusLabel(status: string | undefined): string {
  return STATUS_LABELS[(status ?? "no_recording") as LessonStatus] ?? "No recording";
}
